import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Box, InputAdornment, SvgIcon, TextField } from "@material-ui/core";
import { Search, Search as SearchIcon } from "react-feather";

import Product from "../index";

function SearchProducts({ initialSearch = "", ...props }) {
  const listCategorias = useSelector((state) => state.menu.menu);
  const [search, setSearch] = React.useState(initialSearch);

  const lowerSearch = search.toLowerCase();

  const products = listCategorias.flatMap((categoria) => categoria.itens);

  const filteredProducts = products.filter((product) =>
    product.printDescription.toLowerCase().includes(lowerSearch)
  );

  return (
    <div>
      <Box>
        <TextField
          onChange={(event) => setSearch(event.target.value)}
          value={search}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small" color="action">
                  <SearchIcon />
                </SvgIcon>
              </InputAdornment>
            ),
          }}
          placeholder="Buscar Produtos"
          variant="outlined"
        />
      </Box>
      {filteredProducts.map((prod) => (
        <Product key={prod._id} data={prod} />
      ))}
    </div>
  );
}

export default SearchProducts;
